import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Login from './pages/Login'
import Events from './pages/Events'
import Members from './pages/Members'
import Techniques from './pages/Techniques'
import AdminDashboard from './pages/AdminDashboard'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import AdminPosts from './pages/AdminPosts';
import ContactPage from './pages/ContactPage';
import SettingsPage from './pages/SettingsPage';
import PublicEventRegistration from './pages/PublicEventRegistration';
import EventRegistered from './pages/EventRegistered';
import EventUnsubscribed from './pages/EventUnsubscribed';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { SiteSettingsProvider } from './contexts/SiteSettingsContext'
import { useSiteSettings } from './hooks/useSiteSettings'
import { ThemeProvider } from './contexts/ThemeContext'
import { CartProvider } from './contexts/CartContext'
import Shop from './pages/Shop'
import CartPage from './pages/CartPage'
import MyOrders from './pages/MyOrders'
import GuestOrders from './pages/GuestOrders'
import Board from './pages/Board'
import Showcase from './pages/Showcase'
import SeoMetadata from './components/SeoMetadata'

const ApplicationShell = () => {
  const { settings } = useSiteSettings()

  return (
    <div
      className="app-shell min-h-screen"
      style={settings.pageBackgroundUrl ? { '--page-background': `url(${settings.pageBackgroundUrl})` } as React.CSSProperties : undefined}
    >
      <SeoMetadata />
      <Navbar />
      <main className="relative z-10 mx-auto w-full max-w-[1440px] px-4 py-6 sm:px-6 sm:py-10 lg:px-8">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/boutique" element={<Shop />} />
          <Route path="/bureau" element={<Board />} />
          <Route path="/club" element={<Showcase />} />
          <Route path="/panier" element={<CartPage />} />
          <Route path="/commandes/invite/:token" element={<GuestOrders />} />
          <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
          <Route path="/members" element={<ProtectedRoute><Members /></ProtectedRoute>} />
          <Route path="/adherents" element={<ProtectedRoute><Members /></ProtectedRoute>} />
          <Route path="/techniques" element={<ProtectedRoute><Techniques /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/mes-commandes" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
          <Route path="/event-registered" element={<EventRegistered />} />
          <Route path="/event-unsubscribed" element={<EventUnsubscribed />} />
          <Route path="/event/:eventId/register" element={<PublicEventRegistration />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/posts" element={<AdminRoute><AdminPosts /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

const ApplicationToaster = () => (
  <Toaster
    position="top-right"
    containerStyle={{ zIndex: 200000 }}
    toastOptions={{
      duration: 4000,
      style: {
        border: '1px solid rgb(255 255 255 / .12)',
        borderRadius: '16px',
        background: '#052e1a',
        color: '#fff',
        boxShadow: '0 20px 50px rgb(3 44 19 / .24)',
      },
    }}
  />
)

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SiteSettingsProvider>
          <Router>
            <CartProvider>
              <ApplicationShell />
              <ApplicationToaster />
            </CartProvider>
          </Router>
        </SiteSettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App 
